import React from "react";
import { useTranslation } from "react-i18next";

interface BookingPlgBadgeProps {
  visible: boolean;
}

const BookingPlgBadge: React.FC<BookingPlgBadgeProps> = ({ visible }) => {
  const { t } = useTranslation();

  if (!visible) {
    return null;
  }

  return (
    <div className="text-center mt-4">
      <span className="badge bg-light text-muted border px-3 py-2 fw-normal">
        {t("public_booking.plgBadge")}
      </span>
    </div>
  );
};

export default BookingPlgBadge;
